import React, { useState } from "react";
import "./PricingSection.css";

const PricingSection = () => {
  const [selectedPlan, setSelectedPlan] = useState("premium");

  const plans = [
    {
      id: "standard",
      name: "Standard",
      price: "49€",
      period: "/mois",
      description: "Pour les petites équipes qui démarrent",
      features: [
        "Jusqu'à 5 agents",
        "Planning de base",
        "Support email",
        "Tableau de bord simple",
        "API basique"
      ],
      color: "standard"
    },
    {
      id: "premium",
      name: "Premium",
      price: "99€",
      period: "/mois",
      description: "Pour les entreprises en croissance",
      features: [
        "Jusqu'à 25 agents",
        "IA d'optimisation avancée",
        "Support prioritaire",
        "Analytics complètes",
        "Intégrations multiples",
        "Optimisation géographique"
      ],
      color: "premium",
      popular: true
    },
    {
      id: "maximum",
      name: "Maximum",
      price: "199€",
      period: "/mois",
      description: "Pour les grandes organisations",
      features: [
        "Agents illimités",
        "IA personnalisée",
        "Support dédié 24/7",
        "Rapports avancés",
        "API complète",
        "Formation incluse",
        "Consultation stratégique"
      ],
      color: "maximum"
    }
  ];

  return (
    <section className="pricing-section section-padding">
      <div className="container">
        <div className="pricing-section-header-content-wrapper">
          <h2 className="pricing-section-main-title-heading">Nos Offres</h2>
          <p className="section-subtitle">
            Choisissez le plan qui correspond à vos besoins
          </p>
        </div>
        
        <div className="pricing-grid">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`pricing-card ${plan.color} ${selectedPlan === plan.id ? 'selected' : ''} ${plan.popular ? 'popular' : ''}`}
              onClick={() => setSelectedPlan(plan.id)}
            >
              {plan.popular && (
                <div className="popular-badge">Plus populaire</div>
              )}
              
              <div className="pricing-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price">{plan.price}</span>
                  <span className="period">{plan.period}</span>
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>
              
              <div className="pricing-features">
                <ul>
                  {plan.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
              
              <div className="pricing-footer">
                <button className={`plan-button ${plan.color}`}>
                  Commencer
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="pricing-note">
          <p>💡 Tous nos plans incluent une période d'essai de 14 jours gratuite</p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection; 